import AuthService from "./auth-service";
import axios from "axios";

const BACKEND_SERVER = process.env.REACT_APP_CONTROL_SERVER;

class HttpService {
    #timeout = 600000;
    #operationExceptions = ["login"];
    /**
     * This method is used to send http request.
     * @param {string} method - Method of http request. (get, post, patch, delete)
     * @param {string} service - Service name.
     * @param {string} operation - Operation name.
     * @param {object} addObj - Additional object. (params or body) (optional)
     * @param {string} token - Token. (optional)
     * @returns {Promise} - Promise object. (axios)
     */
    send(
        method,
        service,
        operation,
        addObj = {},
        headers = { "Content-Type": "application/json" }
    ) {
        let headerToken;
        addObj =
            headers["Content-Type"] !== "application/json"
                ? addObj
                : {
                      ...addObj,
                  };
        // token = sessionStorage.getItem("__ApplicationVerification");
        if (!this.#operationExceptions.includes(operation)) {
            headerToken = AuthService.getToken();
            // headerToken = "";
        }
        return this.#handle(
            method,
            addObj,
            `${BACKEND_SERVER}/api/${service}/${operation}`,
            headerToken,
            headers
        );
    }
    #handle(method, sendData, url, token = null, headers = {}) {
        const configs = {
            timeout: this.#timeout,
            headers: token
                ? {
                      Authorization: `Bearer ${token}`,
                      ...headers,
                  }
                : headers,
        };
        if (method === "get") {
            return axios.get(url, {
                params: sendData,
                ...configs,
            });
        } else if (method === "post") {
            return axios.post(url, sendData, {
                ...configs,
            });
        } else if (method === "patch") {
            return axios.patch(url, sendData, {
                ...configs,
            });
        } else if (method === "delete") {
            return axios.delete(url, {
                params: sendData,
                ...configs,
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve({
                    data: {
                        indicator: false,
                        message: "not support this method",
                    },
                });
            });
        }
    }
}

// eslint-disable-next-line
export default new HttpService();
